import { RoutePath } from '..';
import PasskeyIcon from '../../assets/icons/PasskeyIcon';
import Button from '../../components/button';
import { PageContent } from '../../components/modal/styles';
import { useConnectWithWallet } from '../../hooks/useConnectWithWallet';
import useLocales from '../../hooks/useLocales';
import { useRouter } from '../../hooks/useRouter';
import { useWalletProps } from '../../hooks/useWalletsProps';
import { isFirstRegisterPasskey, setFirstRegisterPasskey } from '../../utils';
import { IconWrapper, TipText } from './styles';

const LoginPasskey = () => {
  const locales = useLocales();
  const { navigate } = useRouter();
  const connectWallet = useConnectWithWallet();
  const wallet = useWalletProps('passkeySmartWallet');

  const onRegistration = () => {
    if (isFirstRegisterPasskey()) {
      navigate(RoutePath.PasskeySetup);
      setFirstRegisterPasskey();
    } else {
      connectWithPasskey(true);
    }
  };

  const onAuthentication = () => {
    connectWithPasskey(false);
  };

  const connectWithPasskey = (isRegistering: boolean) => {
    if (wallet) {
      connectWallet(wallet, {
        passkeyParams: {
          isRegistering,
        },
      });
    } else {
      throw new Error('Passkey is not configured.');
    }
  };

  return (
    <PageContent>
      <IconWrapper>
        <PasskeyIcon />
      </IconWrapper>
      <TipText>{locales.usePasskeyToLoginSmartAccount}</TipText>
      <>
        <Button style={{ marginTop: 16 }} onClick={onRegistration}>
          {locales.createNewPasskey}
        </Button>
        <Button
          style={{
            marginTop: 16,
          }}
          onClick={onAuthentication}
          color='secondary'
        >
          {locales.loginWithPasskey}
        </Button>
      </>
    </PageContent>
  );
};

export default LoginPasskey;
